import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './about/HeroSection';
import { AboutSections } from './about/AboutSections';
import { VideoSection } from './about/VideoSection';
import { PodcastSection } from './about/PodcastSection';
export function AboutPage() {
  return <div className="min-h-screen flex flex-col bg-brand-black" data-id="element-196">
      <Navbar data-id="element-197" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-198">
        <HeroSection data-id="element-199" />
        <AboutSections data-id="element-200" />
        <VideoSection data-id="element-201" />
        <PodcastSection data-id="element-202" />
      </main>
      <Footer data-id="element-203" />
    </div>;
}